export default __webpack_public_path__ + "static/media/messages.56d955f0.svg";